import { type ReactNode, createContext, useContext, useEffect, useState } from 'react'

export type HelpVars = Record<string, string>

export interface HelpScopeValue {
  key?: string
  vars?: HelpVars
}

const HelpScopeContext = createContext<HelpScopeValue>({})
const HelpScopeSetter = createContext<(next: HelpScopeValue) => void>(() => {})

export function HelpScopeProvider({ children }: { children: ReactNode }) {
  const [scope, setScope] = useState<HelpScopeValue>({})
  return (
    <HelpScopeSetter.Provider value={setScope}>
      <HelpScopeContext.Provider value={scope}>{children}</HelpScopeContext.Provider>
    </HelpScopeSetter.Provider>
  )
}

export function useHelpScope(): HelpScopeValue {
  return useContext(HelpScopeContext)
}

// Publishes the help card for the current screen. Cleared when the page unmounts.
export function usePublishHelp(key: string, vars?: HelpVars) {
  const setScope = useContext(HelpScopeSetter)
  const serialized = JSON.stringify(vars ?? {})

  useEffect(() => {
    setScope({ key, vars: JSON.parse(serialized) as HelpVars })
    return () => setScope({})
  }, [setScope, key, serialized])
}
